import type { SyncSpaceMeta } from './syncSpaces.js'

export type StartupAccountWorkbenchPlan =
  | { action: 'skip' }
  | {
      action: 'resolve'
      slug: string
      hasLiveMatch: boolean
    }

export function resolveStartupAccountWorkbenchPlan(input: {
  enabled?: boolean
  isAuthenticatedSync: boolean
  isIndexSpace: boolean
  localHasMeaningfulDraft: boolean
  hasActiveAccountShelfBlob: boolean
  localSpaceId: string
  remoteSpaces: SyncSpaceMeta[]
  defaultSlug: string
  normalizeSlug: (spaceSlug: string, spaceId: string) => string
}): StartupAccountWorkbenchPlan {
  if (!input.enabled) return { action: 'skip' }
  if (!input.isAuthenticatedSync) return { action: 'skip' }
  if (input.isIndexSpace) return { action: 'skip' }
  if (!input.localHasMeaningfulDraft) return { action: 'skip' }
  if (input.hasActiveAccountShelfBlob) return { action: 'skip' }

  const liveMatch = input.remoteSpaces.find(space => {
    return !space.deleted_at && space.space_id === input.localSpaceId
  })
  const slug = liveMatch?.space_slug?.trim()
    ? input.normalizeSlug(liveMatch.space_slug, liveMatch.space_id)
    : input.defaultSlug

  return {
    action: 'resolve',
    slug,
    hasLiveMatch: Boolean(liveMatch)
  }
}
